import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import RolesFilters from "../../../components/accessManagement/molecules/RolesFilters";
import RolesTable from "../../../components/accessManagement/organisms/RolesTable";
import CreateRoleDrawer from "../../../components/accessManagement/organisms/CreateRoleDrawer";
import { useAccessManagementRoles } from "./useAccessManagementRoles";
import "../AccessManagement.css";
import "../Users/Users.css";

const AccessManagementRolesPage: React.FC = () => {
  const { functions, values, loading, error, setters } = useAccessManagementRoles();

  return (
    <div className="page-content">
      <Container fluid className="feature-management-page">
        {/* Breadcrumbs */}
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Access Management" },
              { label: "Roles", active: true },
            ]}
          />
        </div>

        {/* Header + Filters */}
        <div style={{ padding: "0 15px", marginBottom: "24px" }}>
          <Row className="align-items-center justify-content-between g-3">
            <Col xs="12" md="auto">
              <h2 className="mb-0">Roles</h2>
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                {`${values.totalCount} roles defined`}
              </p>
            </Col>
            <Col xs="12" md={8}>
              <RolesFilters
                onCreateRoleClick={functions.handleCreateRole}
                searchValue={values.search}
                scopeTypeValue={values.scopeTypeFilter}
                onSearchChange={(v) => {
                  setters.setSearch(v);
                  setters.setPage(1);
                }}
                onScopeTypeChange={(v) => {
                  setters.setScopeTypeFilter(v);
                  setters.setPage(1);
                }}
              />
            </Col>
          </Row>
        </div>

        {/* Roles table */}
        <div style={{ padding: "0 15px" }}>
          <RolesTable
            roles={values.roles}
            loading={loading.isPageLoading}
            error={error}
            onViewRole={functions.handleViewRole}
            onEditRole={functions.handleEditRole}
            page={values.page}
            totalPages={values.totalPages}
            pageSize={values.pageSize}
            totalCount={values.totalCount}
            onPageChange={setters.setPage}
            onPageSizeChange={(size) => {
              setters.setPageSize(size);
              setters.setPage(1);
            }}
          />
        </div>

        <CreateRoleDrawer
          show={values.drawerOpen}
          onHide={functions.handleCloseDrawer}
          mode={values.drawerMode}
          initialData={values.drawerRole ?? undefined}
          onSubmitSuccess={functions.handleSubmitSuccess}
        />
      </Container>
    </div>
  );
};

export default AccessManagementRolesPage;
